/**
 * Safe Harbor Service (studio)
 *
 * Calls the KRO backend Managed Governance activation endpoint
 * (POST /api/v1/safe-harbor/activate) to establish a participant's blockchain
 * comms channel on Canton Network MainNet. The backend persists an auditable
 * activation record and returns the issued channel reference.
 */

const RAW_BASE = process.env.REACT_APP_KRO_API_BASE || 'https://api.kromarketplace.com';
// Some env values already include /api/v1 — normalize to a single prefix.
const API_BASE = RAW_BASE.replace(/\/+$/, '').replace(/\/api\/v1$/, '');
export const SAFE_HARBOR_BASE = `${API_BASE}/api/v1/safe-harbor`;

/**
 * Activate Safe Harbor for a participant.
 * @param {Object} payload - { participantName, participantEmail, participantOrg?, collateral? }
 * @param {AbortSignal} [signal]
 * @returns {Promise<{ success, channel, rail, activatedAt, reused, comms }>}
 */
export async function activateSafeHarbor(payload, signal) {
  const res = await fetch(`${SAFE_HARBOR_BASE}/activate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    signal,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) {
    const msg =
      data?.errors?.[0]?.msg || data?.message || `Activation failed (${res.status})`;
    throw new Error(msg);
  }
  return data;
}

/** Fetch rail + configured comms channel status. */
export async function fetchSafeHarborStatus(signal) {
  const res = await fetch(`${SAFE_HARBOR_BASE}/status`, { signal });
  if (!res.ok) throw new Error(`safe-harbor status ${res.status}`);
  return res.json();
}
